import urlTemplate from 'url-template';

import { errorIfNotOk, stargateFetch } from '../fetch-utils';

const hisiGetFlagTemplate = urlTemplate.parse(
	'/engage-targeting/api/v2/user/{cloudId}/hisi/flag{?userKey,flagKey}',
);

export const hisiSetFlagUrl = '/engage-targeting/api/v2/user/{cloudId}/hisi/flag';

export type GetFlagResponse = {
	status: boolean;
	lastSeenDate: string;
};

export async function getFlag(
	stargateUrl: string,
	cloudId: string,
	flagKey: string,
	userKey: string,
): Promise<GetFlagResponse> {
	return stargateFetch(
		`${stargateUrl}${hisiGetFlagTemplate.expand({
			cloudId,
			userKey,
			flagKey,
		})}`,
		{
			method: 'GET',
		},
	)
		.then(errorIfNotOk)
		.then((r) => r.json());
}

export async function setFlag(
	stargateUrl: string,
	cloudId: string,
	flagKey: string,
	userKey: string,
): Promise<void> {
	return stargateFetch(`${stargateUrl}${hisiSetFlagUrl}`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			userKey: userKey,
			flagKey: flagKey,
		}),
	})
		.then(errorIfNotOk)
		.then((r) => r)
		.then(() => Promise.resolve());
}
